import { useQuery } from '@apollo/client';
import { IonContent } from '@ionic/react';
import { useCallback, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';

import ExpertForm from '@components/forms/ExpertForm';
import HandleQuery from '@components/HandleQuery';
import AppPage from '@components/pageTypes/AppPage';
import { GetExpertDocument, GetExpertQuery, GetExpertQueryVariables } from '@typing/Generated';

type Props = {
  expertId: string;
};

const ExpertManageExpertEditPage = ({ expertId }: Props) => {
  const history = useHistory();
  const intl = useIntl();
  const contentRef = useRef<HTMLIonContentElement>(null);

  const getExpertQuery = useQuery<GetExpertQuery, GetExpertQueryVariables>(GetExpertDocument, {
    variables: { id: expertId }
  });

  const handleFormCancel = useCallback(() => {
    history.push('/expert/manage-experts');
  }, [history]);

  const handleFormSuccess = useCallback(() => {
    history.push('/expert/manage-experts');
  }, [history]);

  const handleFormError = useCallback(() => {
    if (contentRef.current) {
      contentRef.current.scrollToTop(2000);
    }
  }, [contentRef]);

  return (
    <AppPage>
      <Helmet>
        <title>{intl.formatMessage({ id: 'pageTitles.expert.expert.edit' })}</title>
      </Helmet>
      <IonContent className="ion-padding" ref={contentRef}>
        <HandleQuery query={getExpertQuery}>
          {data => (
            <ExpertForm
              autofocus
              expert={data.expert}
              onCancel={handleFormCancel}
              onError={handleFormError}
              onSuccess={handleFormSuccess}
            />
          )}
        </HandleQuery>
      </IonContent>
    </AppPage>
  );
};

export default ExpertManageExpertEditPage;
